import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid, Typography, LinearProgress, Chip, Avatar } from "@mui/material";
import { GoArrowUpRight } from "react-icons/go";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import { useGetDesignKpiComponentsQuery } from "store/slices/apis/designEngineeringDashboardSlice";
import { useGetDesignEngDrawingSummaryQuery } from "store/slices/apis/designEngineeringDashboardSlice";
import { engineeringComponentsMapping } from "./engineeringKpiMapper";
import EngineeringPanelHeader from "./EngineeringPanelHeader";

// const summaryData = [
//     {
//         label: "Site Development",
//         total: 117,
//         received: 92,
//         progressColor: "#12AA5B"
//     },
//     {
//         label: "Warehouse - 01",
//         total: 55,
//         received: 39,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "Driver’s Rest Room",
//         total: 18,
//         received: 9,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "Admin Building",
//         total: 42,
//         received: 17,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "Bonded Warehouse",
//         total: 35,
//         received: 17,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "Truck Parking",
//         total: 2,
//         received: 2,
//         progressColor: "#12AA5B"
//     },
//     {
//         label: "ICD",
//         total: 11,
//         received: 1,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "DCT",
//         total: 27,
//         received: 4,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "PFT Shed",
//         total: 18,
//         received: 2,
//         progressColor: "#1A73E8"
//     },
//     {
//         label: "Hotel",
//         total: 352,
//         received: 7,
//         progressColor: "#1A73E8"
//     },
// ]


const Timelines = () => {
    const { projectId } = useParams()
    // const { data: rawData, error, isLoading } = useGetDesignKpiComponentsQuery({ projectId })
    const { data: rawData, error, isLoading } = useGetDesignEngDrawingSummaryQuery({ projectId })

    const navigate = useNavigate();

    const summaryData = useMemo(() => {
        return engineeringComponentsMapping(rawData?.data);
    }, [rawData]);

    const handleOpenDialog = () => {
        navigate(`/projects/${projectId}/engineering-tracker`);
    };

    if (isLoading) {
        return (
            <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography>Loading Summary Data...</Typography>
            </Box>
        );
    }

    if (error) {
        console.error("Failed to fetch Component Summary:", error);
        return (
            <Box sx={{ p: 4, color: 'red', textAlign: 'center' }}>
                Error loading data: {error.status} - {error.data?.message || "Please try again."}
            </Box>
        );
    }


    return (
        <>
            <EngineeringPanelHeader eyebrow="Submission pipeline" title="Drawing Flow" subtitle="Compare planned drawing volumes with submissions received by discipline." />
            <Grid container sx={{ p: 2 }}>
                <Grid size={12} sx={{ display: "none" }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                    }}>
                        <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#3157C8", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                            Submission pipeline
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 500,
                                fontSize: { xs: "18px", sm: "32px", md: "20px" },
                                lineHeight: { xs: "16px", md: "120%" },
                                color: "#111216",
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            Drawing Flow
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: "140%",
                                color: "#7D7F81",
                                letterSpacing: "1%",
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            Compare planned drawing volumes with submissions received by discipline.
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={12} sx={{ mt: "10px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #DCDCDC", pb: 1 }}>
                        <Typography
                            sx={{
                                borderBottom: "1px dashed",
                                borderColor: "#5F6368",
                                borderDash: "3 3",
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: "140%",
                                color: "#5F6368",
                                letterSpacing: "1%",
                                fontFamily: "Outfit, sans-serif",
                                textTransform: "uppercase"
                            }}
                        >
                            Components
                        </Typography>
                        <Typography
                            sx={{
                                borderBottom: "1px dashed",
                                borderColor: "#5F6368",
                                borderDash: "3 3",
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: "140%",
                                color: "#5F6368",
                                letterSpacing: "1%",
                                fontFamily: "Outfit, sans-serif",
                                textTransform: "uppercase"
                            }}
                        >
                            Total Planned
                        </Typography>
                    </Box>
                    {summaryData?.map((item, index) => {
                        // const percentage = Math.floor((item.received / item.total) * 100)
                        // const stylePercentage = percentage < 35 ? percentage === 0 ? 30 : (2.5 * percentage) + 10 : percentage > 90 ? 95 : percentage + 2.5
                        return <Box key={index} >
                            <Box sx={{ display: "flex", justifyContent: "space-between", position: "relative", mt: 1, mb: 0.5 }}>
                                <Typography sx={{
                                    fontWeight: 400,
                                    fontSize: '12px',
                                    lineHeight: "140%",
                                    color: "#202124",
                                    letterSpacing: "1%",
                                    fontFamily: "Outfit, sans-serif",
                                }}>{item.label}</Typography>
                                <Box sx={{ position: "absolute", left: `${50}%`, top: 0, transform: "translateX(-50%)", display: "flex", alignItems: "center", gap: 1.4 }}>
                                    <Box sx={{ px: 1, py: 0.5, bgcolor: "#E7E7EB", borderRadius: "5px" }}>
                                        <Typography sx={{
                                            fontWeight: 600,
                                            fontSize: '11px',
                                            lineHeight: "100%",
                                            color: "#433F5E",
                                            letterSpacing: "1%",
                                            fontFamily: "Outfit, sans-serif",
                                            whiteSpace: "nowrap"
                                        }}>Received: {item.received}</Typography>
                                    </Box>
                                    <Typography sx={{
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        lineHeight: "100%",
                                        color: "#202124",
                                        letterSpacing: "1%",
                                        fontFamily: "Outfit, sans-serif",
                                    }}>
                                        {/* {(item?.received/item?.total*100) .toFixed(2)}% */}
                                        {item.receivedPercentage}%
                                    </Typography>
                                </Box>
                                <Typography sx={{
                                    fontWeight: 400,
                                    fontSize: '12px',
                                    lineHeight: "100%",
                                    color: "#202124",
                                    letterSpacing: "1%",
                                    fontFamily: "Outfit, sans-serif",
                                }}>{item.total}</Typography>
                            </Box>
                            <LinearProgress
                                variant="determinate"
                                value={item?.received}
                                sx={{
                                    height: 4,
                                    borderRadius: 5,
                                    backgroundColor: '#E8EAED',
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: item.progressColor,
                                        borderRadius: 5,
                                    }
                                }}
                            />
                        </Box>
                    })}
                </Grid>

                <Grid size={12} sx={{ pt: 1 }}>
                    <Typography sx={{
                        fontWeight: 400,
                        fontSize: '16px',
                        lineHeight: "100%",
                        color: "#737791",
                        letterSpacing: "1%",
                        fontFamily: "Outfit, sans-serif",
                    }}>Open the Engineering Tracker to review the underlying drawing register.</Typography>
                    <Box sx={{ bgcolor: "#E7E7EB", width: "309px", height: "33px", borderRadius: "5px", mt: 1, display: "flex", alignItems: "center", justifyContent: "space-between", pl: 2, pr: 5, boxSizing: "border-box" }}>
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: '14px',
                            lineHeight: "100%",
                            color: "#7D7F81",
                            letterSpacing: "1%",
                            fontFamily: "Outfit, sans-serif",
                        }}>Engineering Tracker</Typography>

                        <Avatar
                            onClick={() => handleOpenDialog()}
                            sx={{
                                bgcolor: "#fff",
                                width: "22px",
                                height: "22px",
                                border: "1px solid #fff",
                            }}
                        >
                            <GoArrowUpRight
                                style={{
                                    color: "#0088FF",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                }}
                            />
                        </Avatar>
                    </Box>
                </Grid>

                {/* <Grid size={12} sx={{ mt: "30px" }}>
                    <Box sx={{ display: 'flex', flexDirection: "column", gap: "7px", justifyContent: "flex-start" }}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '15px',
                                color: '#6C757D',
                                fontFamily: "Outfit, sans-serif",

                            }} >
                            Avg Drawing Approval Time
                        </Typography>
                        <LinearProgress
                            variant="determinate"
                            value={55}
                            sx={{
                                height: 34,
                                borderRadius: "5px",
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: "#0096FF",
                                    borderRadius: 0,
                                }
                            }}
                        />
                    </Box>

                </Grid>
                <Grid size={12}>
                    <Box sx={{
                        border: "1px solid #FFFFFF0A",
                        bgcolor: "#E7E7EB",
                        borderRadius: "3px",
                        p: 2,
                        mt: "30px",
                        maxHeight: {xs:"auto",md:"153px"}
                    }}>
                        <Typography
                            sx={{
                                fontWeight: 500,
                                fontSize: '16px',
                                lineHeight: "24px",
                                color: "#111216",
                                fontFamily: "Outfit, sans-serif",
                            }}
                        >
                            Drawing Submission Compliance
                        </Typography>
                        <Box sx={{
                            display: "flex", flexDirection:{xs:"column", md:"row"}, alignItems: "center", justifyContent: "space-between"
                        }}>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '30px',
                                    lineHeight: "30px",
                                    color: "#34C759",
                                    fontFamily: "Outfit, sans-serif",
                                }}
                            >
                                80% compliant
                            </Typography>
                            <Box sx={{ p: 0, m: 0 }}>
                                <HighchartsReact highcharts={Highcharts} options={options} />
                            </Box>

                        </Box>
                    </Box>
                    <Box
                        sx={{
                            width: {xs:"auto",md:"309px"},
                            height: "50px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            bgcolor: "#E7E7EB",
                            p: 2,
                            mt: "30px",
                            borderRadius: "3px"
                        }}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '14px',
                                lineHeight: "140%",
                                color: "#7D7F81",
                                letterSpacing: "1%",
                                fontFamily: "Outfit, sans-serif",
                            }}
                        >
                            Engineering Tracker
                        </Typography>
                        <Avatar
                            // onClick={() => handleOpenDialog(card)}
                            sx={{
                                bgcolor: "#0088FF",
                                width: "35px",
                                height: "35px",
                                border: "1px solid #d3d3d3",
                            }}
                        >
                            <GoArrowUpRight
                                style={{
                                    color: "Accents/Blue",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                }}
                            />
                        </Avatar>
                    </Box>
                </Grid> */}

            </Grid>
        </>
    );
};

export default Timelines;
